import { useAuth, useAuthCallback } from "@allergy123/auth-client/react";
import { AuthPanel, Button, Status } from "@allergy123/ui";
import { useNavigate } from "react-router";

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const result = useAuthCallback((to) => navigate(to, { replace: true }));
  const { signIn } = useAuth();
  if (result.state === "error") {
    return (
      <AuthPanel logoVariant="auto" title="We couldn't finish signing you in">
        <p className="mb-4">The sign-in link may have expired or been used already. Start again and it should work.</p>
        <Status kind="error" label={result.error ?? "Sign-in failed"} className="mb-6 block" />
        <Button onClick={() => void signIn("/")}>Sign in again</Button>
      </AuthPanel>
    );
  }
  return (
    <AuthPanel logoVariant="auto" title="Signing you in">
      <p className="text-ink-secondary">One moment.</p>
    </AuthPanel>
  );
}

export function SignedOutPage() {
  const { signIn } = useAuth();
  return (
    <AuthPanel logoVariant="auto" title="You're signed out">
      <p className="mb-6">Sign in again to return to the clinic.</p>
      <Button onClick={() => void signIn("/")}>Sign in</Button>
    </AuthPanel>
  );
}

export function NoAccessPage() {
  const { session, signOut } = useAuth();
  return (
    <AuthPanel logoVariant="auto" title="Clinic access required" footer={session?.claims.email ? `Signed in as ${session.claims.email}` : undefined}>
      <p className="mb-6">This app is for practice staff with clinical access. Your account has no practice membership with clinical permissions, or two-step verification isn't set up yet.</p>
      <Button variant="secondary" surface="card" onClick={() => void signOut()}>
        Sign out
      </Button>
    </AuthPanel>
  );
}
